<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>
<main>
  <app-headline-section [title]="hostName" [badge]="popout ? 'Screen ' + (active()! + 1) : undefined">
  </app-headline-section>

  <section class="cl-section cl-section-regular">
    <div class="container">

      <!-- Actions -->
      @if (activeStream()?.connected() || password()) {
        <p class="alert cl-alert-action">
          @if (activeStream()?.connected()) {
            <a role="button" (click)="toggleFullscreen()">Fullscreen</a>
            <!-- For every screen in this browser, pop-outs too (CrdDisplaySetting). One action: the current mode as
                 text, the others as links. -->
            <span class="crd-display" role="group" aria-label="Display">
              Display:
              @for (m of displayModes; track m.mode; let first = $first) {
                @if (!first) {
                  <span class="crd-display-separator" aria-hidden="true">·</span>
                }
                @if (displayMode() === m.mode) {
                  <span class="crd-display-mode crd-display-current" aria-current="true" [title]="m.title">{{ m.label }}</span>
                } @else {
                  <a class="crd-display-mode" role="button" tabindex="0" [title]="m.title" (click)="setDisplayMode(m.mode)"
                     (keydown.enter)="setDisplayMode(m.mode)" (keydown.space)="$event.preventDefault(); setDisplayMode(m.mode)">{{ m.label }}</a>
                }
              }
            </span>
          }
          @if (password()) {
            <a role="button" (click)="showPassword.set(!showPassword())">
              @if (showPassword()) {
                <i class="fas fa-eye-slash"></i> Hide Password
              } @else {
                <i class="fas fa-eye"></i> Show Password
              }
            </a>
          }
        </p>
      }

      @if (popupBlocked()) {
        <div class="cl-alert cl-alert-warning" role="alert">
          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
          The browser blocked the new window. Allow pop-ups for this site and try again.
        </div>
      }

      <!-- Password (hidden until revealed) -->
      @if (password() && showPassword()) {
        <p>Password: <span class="cl-font-monospace">{{ password() }}</span></p>
      }

      @if (popout) {
        <!-- The window of one screen: no tabs; audio only when the session page hands it over. -->
        @if (returned()) {
          <div class="cl-alert cl-alert-info" role="alert">
            <p>Screen {{ active()! + 1 }} is back in the session page. You can close this window.</p>
          </div>
        }
        @if (opened().includes(active()!)) {
          <app-crd-stream [pool]="pool" [hostId]="hostId" [hostName]="hostName" [region]="region"
                          [monitor]="active()!" [active]="true" [audible]="audible() === active()" (joined)="onJoined($event)" />
        }
      } @else {
        <!-- The castLabs UI tab markup, as app-cl-tabs renders it. Not app-cl-tabs itself: that always
             opens on its first tab, and this page opens on the screen the link names. The radios' checked
             state follows active(); a panel only gets its stream once its tab has been opened. -->
        @if (active() === null) {
          <div class="cl-alert cl-alert-info" role="status">
            <p>Choose a screen to connect to it here, or open it in a window of its own with the icon next to its name.</p>
          </div>
        }
        <div class="cl-tabs">
          @for (m of screens; track m) {
            <input type="radio" class="cl-tab-{{ m + 1 }}" id="crd-screen-{{ m + 1 }}" name="crd-screen"
                   [checked]="active() === m" (change)="select(m)">
          }
          <ul>
            @for (m of screens; track m) {
              <li class="cl-tab-{{ m + 1 }}">
                <label for="crd-screen-{{ m + 1 }}">Screen {{ m + 1 }}</label>
                <!-- Outside the label: opens the screen straight in its own window, without switching tabs or
                     joining it here first. -->
                @if (!moved().includes(m)) {
                  <a class="crd-popout" role="button" tabindex="0" (click)="openInWindow(m)" (keydown.enter)="openInWindow(m)"
                     title="Open Screen {{ m + 1 }} in a new window" [attr.aria-label]="'Open Screen ' + (m + 1) + ' in a new window'">
                    <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                  </a>
                }
              </li>
            }
          </ul>
          @for (m of screens; track m) {
            <div class="cl-tab-content cl-tab-{{ m + 1 }}">
              @if (moved().includes(m)) {
                <div class="cl-alert cl-alert-info" role="status">
                  <p>Screen {{ m + 1 }} is shown in a window of its own.</p>
                </div>
                <p><a class="cl-a-btn" role="button" (click)="bringBack(m)">Bring Back Here</a></p>
              } @else if (opened().includes(m)) {
                <app-crd-stream [pool]="pool" [hostId]="hostId" [hostName]="hostName" [region]="region"
                                [monitor]="m" [active]="active() === m" [audible]="audible() === m"
                                (joined)="onJoined($event)" />
              }
            </div>
          }
        </div>
      }

    </div>
  </section>
</main>
